// @json
import textEn from './text-en.json';

const Text = {
  en: textEn
};

export default Text;
